module.exports = __webpack_public_path__ + "static/climate-cabinet-569881a86db5323024971893f575c48e.png";